module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'UsuariosLista'
      })
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Níveis de acesso")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.roles), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "to": {
          name: 'RolesEditar',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [(item.limitado_tarefas) ? _c('span', [_vm._v("Limitado por tarefas")]) : _vm._e(), _vm._v(" "), (item.limitado_proprietario) ? _c('span', [_vm._v(" | Limitado por proprietário")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'RolesAdicionar'
      })
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26dab735"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/RolesLista.vue
// module id = 999
// module chunks = 1